/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PraticaEsercenteSubmitForm { 
    tipo_pratica_id: string;
    form_data?: { [key: string]: any; };
    negozi_ids?: Array<string>;
}

